module.exports = __webpack_public_path__ + "static/media/Icon.91546e31.tiff";